module.exports = __webpack_public_path__ + "img/bg03.ff753660.gif";